module.exports = __webpack_public_path__ + "img/cyan.5d6d06aa.png";